module.exports = __webpack_public_path__ + "assets/img/label-classify-7.a92b7bdd.png";